module.exports["input"] = "_CreateInvoice__input";
module.exports["output"] = "_CreateInvoice__output";